var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats text-shadow-thin-black"},[_c('div',{staticClass:"clock"},[_c('p',{staticClass:"stats-val"},[_vm._v(_vm._s(_vm.formattedSecondsLeft))])]),_c('div',{staticClass:"points"},[_c('p',{staticClass:"stats-val"},[_vm._v(_vm._s(_vm.points)+" "+_vm._s(_vm.$t("utils.pts")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }